import { render, staticRenderFns } from "./AppDeleteButton.vue?vue&type=template&id=92292704&"
import script from "./AppDeleteButton.vue?vue&type=script&lang=js&"
export * from "./AppDeleteButton.vue?vue&type=script&lang=js&"
import style0 from "./AppDeleteButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92292704')) {
      api.createRecord('92292704', component.options)
    } else {
      api.reload('92292704', component.options)
    }
    module.hot.accept("./AppDeleteButton.vue?vue&type=template&id=92292704&", function () {
      api.rerender('92292704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppDeleteButton.vue"
export default component.exports